module.exports = {
    newIcon: 'NEW',
    genericRegisterCardErrorMessage: 'There was a problem linking the card please try again later',
    linkCardSuccessMessage: 'Card successfully linked',
    cardAlreadyLinked: 'This card is already linked to this account',
    invalidCvvErrorMessage: 'Please enter a valid cvv number',
    invalidCardNumberErrorMessage: 'Please enter a valid card number',
    invalidCardAndCvvErrorMessage: 'Please enter a valid card and cvv number',
    feedback: {
        buttonText: 'Sparks Colleague Trial Feedback',
        line1: 'Problems with the new Sparks experience?',
        line2: 'Let us know by filling out this survey.',
        mdWidth: 599,
        smWidth: 286
    },
    cardNotScanningMessage1: 'Still having issues in scanning?',
    cardNotScanningMessage2: 'Just ask a customer assistant to type your card number in',
    fullDetailsText: 'Full details',
    rewardCardTitle: 'Claim your FREE treat!',
    rewardCardAddedTitle: 'Your FREE treat...enjoy!',
    findStore: 'Find a store nearby',
    findStoreHref: 'https://www.marksandspencer.com/MSResStoreFinderGlobalBaseCmd?langId=-24&storeId=10151&catalogId=10051',
    instoreOnly: 'IN STORE ONLY',
    instoreTreat: 'IN-STORE GIFT',
    instoreAndOnline: 'IN STORE & ONLINE',
    onlineOnly: 'ONLINE ONLY',
    reward: {
        product: {
            titlePrefix: '',
            description: 'Pick up a bag of your choice from our range of Percy Pigs and his friends',
            claimTitle: 'HOW TO CLAIM',
            claimStep1: 'Hit the + icon to add to your Sparks card',
            claimStep1Done: 'You\'ve successfully added a gift to your card',
            claimStep1SRP: 'You\'ve successfully added a reward to your card',
            instore: {
                claimStep2: 'Pick up your treat in store',
                claimStep2b: 'Now pick up your treat in store',
                claimStep2SRP: 'Now pick up your reward in store',
                claimStep3: 'Scan your card at the checkout',
                claimNote: 'PLEASE NOTE : This product may not be available in all stores.'
            },
            instoreAndOnline: {
                claimStep2: 'Pick up your treat in store or add it to your bag online',
                claimStep3: 'Scan your card at the checkout and the discount will be automatically applied',
                claimNote: 'PLEASE NOTE : This product is subject to availability.'
            },
            online: {
                claimStep2: 'Add to your bag',
                claimStep3: 'Discount will be automatically applied',
                claimNote: 'PLEASE NOTE : This product is subject to availability.'
            },
            singleUse: 'SINGLE USE : Can be used only once in a single transaction. Subject to availability',
            showStoreListText: 'SHOW STORE LIST',
            terms: 'TERMS AND CONDITIONS'
        },
        voucher: {
            titlePrefix: '',
            description: 'Pick up a bag of your choice from our range of Percy Pigs and his friends',
            claimTitle: 'HOW TO CLAIM',
            claimStep1: 'Add the voucher to your card',
            claimStep3: 'Discount will be automatically applied',
            instore: {
                claimStep2: 'Shop in store'
            },
            instoreAndOnline: {
                claimStep2: 'Shop in store or online'
            },
            online: {
                claimStep2: 'Shop online'
            },
            singleUse: 'SINGLE USE : Can be used only once in a single transaction. Subject to availability',
            showStoreListText: 'SHOW STORE LIST',
            terms: 'TERMS AND CONDITIONS'
        },
        pickATreat: {
            leftContentTopText: 'Choose from:',
            leftContentImageSeperator: '-OR-',
            titlePrefix: 'WHAT\'S WAITING FOR YOU?',
            description: 'Enjoy a gift on us - simply pick it up next time you shop in store.',
            buttonPreClick: 'Add gift to card',
            buttonPostClick: 'Added to card',
            claimTitle: 'HOW TO CLAIM',
            claimStep3: ' Scan your gift and Sparks card at the till - it\'s on us',
            claimNote: 'PLEASE NOTE: Gifts may not be available in all stores',
            preClick: {
                claimStep1: ' Hit the + icon to add to your Sparks card',
                claimStep2: ' Come in store and select your preferred gift'
            },
            postClick: {
                claimStep1: ' You\'ve successfully added a gift to your card ',
                claimStep2: ' Now choose your preferred gift in store'
            },
            singleUse: 'SINGLE USE : Can be used only once in a single transaction. Subject to availability',
            showStoreListText: 'SHOW STORE LIST',
            terms: 'TERMS AND CONDITIONS'
        }
    },
    streak: {
        titlePrefix: 'EARN A FREE ',
        descriptiona: 'Collect a stamp when you buy an M&S ',
        descriptionb: ' in store. You\'ll earn one stamp per ',
        descriptionc: '. Collect 4 stamps to earn a free ',
        descriptiond: '.',
        buttonPreClick: 'Start earning',
        buttonPostClick: 'You\'ve started earning',
        claimTitle: 'HOW TO EARN',
        claimStep3: 'Scan your ',
        claimStep3b: ' and Sparks card at the till to earn your stamps',
        preClick: {
            claimStep1: ' Hit \'Start earning\' to link Sparks Stamps to your Sparks card',
            claimStep2: ' Come in store and select your preferred '
        },
        postClick: {
            claimStep1: ' You\'ve successfully linked Sparks Stamps to your Sparks card ',
            claimStep2a: ' Now choose your preferred ',
            claimStep2b: ' in store'
        },
        terms: 'TERMS AND CONDITIONS',
        singleUseText1: 'SINGLE USE: This offer can only be used once to earn one free ',
        singleUseText2: '. Subject to availability.',
        streakCompletePrefix: 'Enjoy your free '
    },
    spendAndSave: {
        titlePrefix: 'EARN YOUR save REWARD',
        description: 'Spend SPEND on M&S food when you shop in store, either in a single transaction or over multiple visits, and we\'ll give you SAVE off your next in-store shop.',
        buttonPreClick: 'Start earning',
        buttonPostClick: 'You\'ve started earning',
        claimTitle: 'HOW TO EARN',
        claimStep2a: 'Now shop ',
        claimStep2b: ' in store',
        claimStep3: 'Scan your items and Sparks card at the till to track your progress',
        preClick: {
            claimStep1: ' Hit \'Start earning\' to link Spend & Save to your Sparks card'
        },
        postClick: {
            claimStep1: 'You\'ve successfully linked the reward to your Sparks account'
        },
        terms: 'TERMS AND CONDITIONS',
        singleUseText1: 'SINGLE USE: This offer can only be used once to earn one free ',
        singleUseText2: '. Subject to availability.'
    },
    visitBasedStreak: {
        description: 'Shop OFFERNAME VISITS times (minimum spend SPEND) and we\'ll give you SAVE off the next time you buy food in store',
        claimStep2: ' Come in store and shop OFFERNAME',
        claimStep3: 'Scan your items and Sparks card at the till (or pay via Scan & Shop) to track your progress',
        preClick: {
            claimStep1: ' Hit ‘Start earning’ to link the offer to your Sparks account'
        },
        postClick: {
            claimStep1: 'You\'ve successfully linked the offer to your Sparks account'
        },
        firstStampDesc: 'You\'re off to a great start. Spend SPEND, VISITLEFT more times and get GETOFFER off your next shop'
    },
    newOffersAdviceText: 'Add the ones you like and they\'ll be applied at checkout',
    newOfferAdviceTextOne: 'Like the offer shown? Add it and it\'ll be applied at checkout',
    addedOffersAdviceText: 'These offers will be automatically applied at the checkout',
    activateAllOffersButtonText: 'Add all offers',
    activateAllOffersAndRewardsButtonText: 'Add all',
    mobileCarouselShrinkPercentage: 10,
    shopOfferButtonText: 'Shop the offer',
    findAStoreButtonText: 'Find a store',
    noNewOffersTitle: 'You\'ve added all your Sparks offers',
    noNewOffersText: 'They\'re waiting on your card, so why not start shopping?',
    noNewOffersButtonText: 'See your offers',
    viewMSOffersHref: '/c/offers',
    noAddedOffersTitle: 'Oh no, you haven\'t loaded any offers!',
    noAddedOffersText: 'Start adding new offers to your Sparks card below',
    noAddedOffersButtonText: 'See new offers',
    noOffersTitle: 'You don\'t have any offers at the moment',
    noOffersText: 'Don\'t worry we still have plenty of M&S offers you can use',
    noOffersButtonText: 'View M&S offers',
    charityText: 'Your Sparks',
    charityPageText:'Your Sparks charity',
    chosenCharityText: 'For your charity, we\'ve raised',
    editCharityText: 'Change charity',
    editCharityLink: '/mysparks/mycharity',
    editCharityHubLink: '/mysparks/mycharity?anchorCharitySettings=true',
    popularItemsText: 'POPULAR ITEMS IN THIS OFFER',
    readTermsText: 'Read complete terms and conditions',
    addToCardButtonText: 'Add to card',
    linkCardText: 'Link physical card',
    cardNotScanningText: 'Card not scanning?',
    newOffersToggleText: 'New offers',
    offersAddedToggleText: 'Added Offers',
    bannerTitleText: 'GOOD THINGS HAPPEN EVERY TIME YOU SHOP',
    holdingPageTitleText: 'ACTIVATE YOUR SPARKS ACCOUNT',
    holdingPageTitleDesc: 'Check your email and activate your account to start receiving the benefits of Sparks!',
    holdingPageContentText: 'Didn\'t receive an email?',
    holdingPageContentDesc: 'Check your junk email or resend',
    holdingPageCtaText: 'Resend activation email',
    holdingPageCtaUrl: '/TODO',
    welcomeXText: 'Welcome ',
    okText: 'OK',
    errorHeader: 'Unable to add offer',
    errorDesc: 'Unable to add your selected offer at this moment',
    offersAddedLabel: 'All offers added to sparks card',
    offerAppliedLabel: 'Add the ones you like and they\'ll be applied at checkout',
    smWindowBreakpoint: 600,
    mdWindowBreakpoint: 768,
    lgWindowBreakpoint: 1024,
    xlWindowBreakpoint: 1280,
    cardsAcrossWindow: 3,
    otherCharitiesTitle: 'Other Charities',
    chooseCharityTitle: 'YOU CURRENTLY SUPPORT',
    chooseCharityName: 'All our charities',
    chooseCharityText: 'Choose a charity',
    chooseCharityLink: '/mysparks/mycharity',
    chooseCharityHubLink: '/mysparks/mycharity?anchorCharitySettings=true',
    hubLink: '/mysparks',
    allCharityRaisedTitle: 'In total, you\'ve helped us raise',
    moreInfoCharityText: 'More info',
    loginUrl: '/webapp/wcs/stores/servlet/MSLogoff?catalogId=10051&langId=-24&storeId=10151&rememberMe=true&WcUseHttps=true&viewTaskName=RedirectView&URL=',
    charitySettingTitle: 'Donating with Sparks',
    charitySettingsText: 'Every time you shop with Sparks, we’ll donate to your chosen charity*.',
    charitySettingsTextWithFootnote: 'Every time you shop with Sparks, we’ll donate to your chosen charity*.',
    charityFootnote: '*For every transaction you make where you scan your Sparks card or are logged in to M&S with your Sparks account, M&S will donate 1p to charity. **The good causes M&S supports through Sparks include both registered charities and social enterprises.',
    supportAllCharitiesButtonText: 'Support all Charities',
    supportingAllCharitiesConfirmationBoxText: 'Supporting all Charities',
    sessionInactiveTime: 1800,
    charityButtonText: 'See all charities',
    bannerContainerTitleForJoinSparks: 'From big treats to little thank yous and a charity donation with every purchase',
    appDownloadSectionTitle: 'SCAN YOUR CARD FOR GOOD THINGS EVERY TIME YOU SHOP',
    appDownloadBoldText: 'Your Sparks card is also digital',
    appDownloadBodyText: 'Download the M&S app to scan your card straight from your phone, and keep track of offers and rewards.',
    appDownloadFooterText1: 'Need help',
    appDownloadFooterText2: 'downloading the app?',
    appDownloadFooterLinkText: 'Sparks FAQs',
    sparksFAQsLinke432: 'https://www.marksandspencer.com/c/mobile-apps',
    appStoreAppDownloadLink: 'https://mandsapp.onelink.me/256943915/c9e7da17',
    googlePlayAppDownloadLink: 'https://mandsapp.onelink.me/256943915/dc5153fc',
    signin: 'Sign in',
    register: 'Register',
    joinsparks: 'Join Sparks',
    login: 'Log in',
    seeYourOffersButtonText: 'View Sparks offers',
    sparksBenefitsTitleNonSparksCustomer: 'WELCOME TO SPARKS AND<BR>REWARDS YOU\'LL LOVE',
    sparksBenefitsTitleSparksCustomer: 'WE\'RE KEEPING THE THINGS YOU LOVE',
    sparksBenefitsTitleNonSparksCustomerSm: 'WELCOME TO SPARKS<BR>AND REWARDS YOU\'LL<BR>LOVE',
    sparksBenefitsTitleSparksCustomerAddThese: 'AND ADDING THESE.....',
    sparksBenefitsPersonalisedOffers: 'Personalised offers',
    sparksBenefitsPersonalisedOffersDesc: 'We\'ll give you personalised offers based on the things you love',
    sparksBenefitsCharityDonation: 'Charity donation',
    sparksBenefitsCharityDonationDesc: 'Whenever you scan your card, we\'ll donate to your chosen charity',
    sparksBenefitsLittleThankYous: 'Little thank yous',
    sparksBenefitsLittleThankYousDesc: 'Every week we\'ll surprise some lucky customers with a little gift',
    sparksBenefitsChanceToGet: 'Your shopping for FREE',
    sparksBenefitsChanceToGetDesc: 'Every week in store, we\'ll treat a Sparks customer to the shopping they\'re buying for free',
    sparksBenefitsChanceToWin: 'Plus there\'s even more…',
    sparksBenefitsChanceToWinDesc: 'We\'ll be giving away thousands of pounds to spend at M&S, in store or online. Imagine that!',
    sparksBenefitsPartnership: 'Exclusive partnerships',
    sparksBenefitsPartnershipDesc: 'Access to offers and experiences from our carefully chosen partners',
    registerFromJoinsparksLink: '/webapp/wcs/stores/servlet/MSResUserRegistration?catalogId=10051&myAcctMain=1&langId=-24&storeId=10151&isSparksRelaunch=Y&intid=sparksnav_landing_register_<button_location>',
    analyticsAllCharitiesTxt: 'all charities',
    analyticsWelcomeOfferPromptInfoText: 'Activate your Sparks offers before you shop',
    signInFromJoinsparksLinkPart1: '/webapp/wcs/stores/servlet/MSResLogin?catalogId=10051&langId=-24&storeId=10151&isSparksRelaunch=Y&rememberMe=true&WcUseHttps=true&viewTaskName=RedirectView&intid=sparksnav_landing_signin_<button_location>&URL=',
    signInFromJoinsparksLinkPart2: '/mysparks',
    marketingPreferencesTitle1: 'Marketing preferences',
    marketingPreferencesTitle2: 'Never miss a thing',
    marketingPreferencesDesc: 'We\'d like to send you exclusive offers, rewards, promotions and news',
    marketingPreferencesOption1: 'Yes, I\'d like to receive updates via email and/or text about your products and services and those offered by your partners',
    marketingPreferencesOption2: 'No thanks',
    marketingPreferencesChangeMind: 'If you change your mind, you can opt out at any time.',
    joinSparksLink: '/joinsparks',
    singleUseHeader: 'SINGLE USE OFFER',
    singleUseText: 'Can be used only once in a single transaction. Subject to availability.',
    tncsHeader: 'TERMS & CONDITIONS',
    colleagueFeedbackSurveyUrl: 'https://www.surveymonkey.co.uk/r/ZJGHQRP?channel=web&user=$sparksCardNumber&page=$feedbackPageName',
    onboardingExistingUserTitle1: 'NEW SPARKS IS HERE',
    onboardingNewUserTitle1: 'WELCOME TO SPARKS',
    onboardingExistingUserDesc1: 'After listening to your feedback, we\'ve made Sparks even more rewarding. Take a look at what\'s in store for you.',
    onboardingNewUserDesc1: 'We can\'t wait for you to enjoy all the new benefits! Take a look at what\'s in store for you.',
    onboardingTitle2: 'OFFERS JUST FOR YOU',
    onboardingNewTitle2: 'PERSONALISED OFFERS',
    onboardingDesc2: 'We\'ll keep giving you personalised offers based on the things you love. Add them and they\'ll be applied at checkout.',
    onboardingNewDesc2: 'We\'ll give you personalised offers based on the things you love. Add them and they\'ll be applied at checkout.',
    onboardingTitle3: 'CHARITY DONATION',
    onboardingDesc3: 'Every time you shop with your Sparks card we\'ll donate to your chosen charity – and now, there are even more to choose from.',
    onboardingTitle4: 'LOOK OUT FOR TREATS',
    onboardingDesc4: 'We\'ll surprise lucky customers with little thank yous, and every week in every store someone will get their shopping for free!',
    onboardingNewTopTitle5: 'YOUR DIGITAL CARD',
    onboardingNewTitle5: 'YOU\'RE READY TO GO!',
    onboardingNewDesc5: 'Just scan your Sparks card every time you shop. Don\'t forget to <a>link</a> your physical Sparks card to your account.',
    onboardingPreviousText: 'Previous',
    onboardingNextText: 'Next',
    onboardingTreatLink: 'Get your offers',
    redeemedTagText: 'REDEEMED',
    charityDonationEmptyTitle: 'THIS IS A NEW CHARITY',
    charityDonationEmptyDesc: 'Check back soon to see how<br>much you\'ve raised',
    hubAppDownloadSectionTitle: 'Here\'s £<xx> on us',
    hubAppDownloadBoldText: 'Login to the M&S app on your mobile device to claim your treat',
    hubAppDownloadBodyText: 'Don\'t forget you can now scan your Sparks card straight from your phone',
    onboardingExisitingUserScreenNames: ['Your new and improved sparks', 'We are keeping offers', 'Adding more charities', 'Look out for treats'],
    onboardingNewUserScreenNames: ['Welcome to sparks', 'Personalised offers', 'Charity contribution', 'Look out for treats'],
    transitionJourneyText: 'WELCOME_TRANSITION_JOURNEY',
    newJourneyText: 'WELCOME_NEW_CUST_JOURNEY',
    errorMessage: 'We had an issue creating your account, please try again.',
    voucherCardTitle: 'Claim your FREE gift!',
    voucherCardSubTitle: 'off your next shop*',
    voucherCardAddedTitle: 'Your FREE gift...enjoy!',
    appOnlyRewardVoucherType: 'REWARD_VOUCHER_APPONLY',
    joinPageDesc: 'Good things happen every time you shop with M&S Sparks. From big treats to little thank yous and a charity donation with every purchase, join Sparks for rewards you\'ll love.',
    hubPageDesc: 'Good things happen every time you shop with M&S Sparks. From big treats to little thank yous and a charity donation with every purchase.',
    charityPageDesc: 'Every time you shop with Sparks, whether in store or online, we donate to your chosen charity. Together, we\'ve raised almost £7 million so far. We\'ve spoken to our colleagues and listened to our customers to find out more about the causes that matter to them most, and have added 25 new charities to Sparks. Take a look below to discover all of our Sparks charities and the amazing work they do.',
    aboutPageDesc: 'Want to find out more about Sparks, the reward scheme from M&S? There are big treats, little thank yous and a charity donation with every purchase.',
    aboutBannerTitle: 'Love M&S, Love Savings, Love Sparks',
    aboutSparksSubTitle: 'Enjoy great savings on the things you love with Sparks',
    checkOffersText: 'Check your offers',
    aboutLinkCardText: 'Link your physical card',
    rewardTypeProduct: 'REWARD_PRODUCT',
    rewardTypeVoucher: 'REWARD_VOUCHER',
    rewardType2Choice: 'REWARD_2CHOICEPRODUCT',
    rewardTypeChristmas: 'REWARD_XMAS2020',
    rewardTypeShopForAYear: 'REWARD_SHOP_FOR_A_YEAR',
    rewardTypeRAFVoucher: 'REWARD_RAF_VOUCHER',
    rewardTypeRAFProduct: 'REWARD_RAF_PRODUCT',
    rewardTypeRAFDiscount: 'REWARD_RAF_DISCOUNT',
    personalisedOfferTitleTxt: 'PERSONALISED OFFERS',
    rewardTypeStreakComplete: 'REWARD_STREAK_COMPLETE',
    rewardTypeVoucherStreakComplete: 'REWARD_VOUCHER_STREAK_COMPLETE',
    rewardTypeAlwaysOnStreakComplete: 'REWARD_STREAK_ALWAYSON_COMPLETE',
    appOnlyType: 'APPONLY',
    streakTypeFlexi: 'FLEXI_STREAK',
    streakTypeVisitsBased: 'VISIT_STREAK',
    personalisedOfferTxt: 'We\'ll give you personalised offers based on the things you love. Add them and they\'ll be applied at checkout.',
    landingPageVideoUrlProspectiveCustomer: 'https://www.youtube.com/embed/aaNbX734N34',
    landingPageVideoUrlExistingUser: 'https://www.youtube.com/embed/7-wfgOcYS9w',
    landingPageVideoSettings: '?fs=1&rel=0&enablejsapi=1&playerapiid=myytplayer&modestbranding=1',
    personalisedTreatTitleTxt: 'LOOK OUT FOR TREATS',
    personalisedTreatTxt: 'We\'ll surprise lucky customers with little thank yous, and every week in every store someone will get their shopping for free!',
    aboutSparksCharityButtonText: 'See all charities',
    aboutPageMobileTailoredToYouText: 'SPARKS AT YOUR FINGERTIPS',
    aboutPageMobileHowToUseBoldText1: 'Add your offers and',
    aboutPageMobileHowToUseBoldText2: 'rewards with just one tap',
    discoverSparksBannerTitleExistingCustomer: 'DISCOVER YOUR NEW SPARKS',
    discoverSparksBannerBodyExistingCustomer: 'Now there are even more benefits to being a Sparks customer',
    discoverSparksBannerLink: 'Explore Sparks',
    discoverSparksBannerTitleNewCustomer: 'DISCOVER REWARDS YOU\'LL LOVE',
    discoverSparksBannerBodyNewCustomer: 'There are lots of benefits to being a Sparks customer',
    appDownloadHubLink: 'https://mandsapp.onelink.me/256943915',
    iosMetaTag: '/mysparks?intid=mobile_app_smartappbanner_from_sparks',
    bannerTitleTextMobile: 'GOOD THINGS HAPPEN<BR>EVERY TIME YOU SHOP',
    dotComPlusUrls: {
        'signOut': '/Logoff',
        'customerSearch': '/MSCSAdvancedSearchForm',
        'wrapup': '/RestoreOriginalUserSetInSession?catalogId=10051&wrapUp=true&langId=-24&wrapUpUrl=/webapp/wcs/stores/servlet/TopCategoriesDisplayView?catalogId=10051&langId=-24&storeId=10151&storeId=10151&intid=sparks_hub_signout'
    },
    chooseTreatTitleTop: 'You\'ve got',
    chooseTreatTitleBottom: 'a free gift',
    bookASlotExp: 'BOOK_A_SLOT',
    bookSlotDesc: 'Reserve a slot to shop in store, so you won\'t have to queue when you arrive.',
    bookSlotHeadBook: 'BOOK',
    bookSlotHeadAmp: '&',
    bookSlotHeadShop: 'SHOP',
    bookSlotCTA: 'Book now',
    voucherCardValueKeyText: 'VALUE',
    voucherCardExpiryKeyText: 'EXPIRY',
    voucherCardShowDetailLinktext: 'SHOW GIFT CODE',
    gitfCardCodeTitle: 'Gift Card',
    giftCardInStoreTitle: 'In-store gift card',
    giftCardOnlineTitle: 'Online gift card',
    giftCardCodeNumberKey: 'CARD NUMBER',
    giftCardCodePinKey: 'PIN',
    giftCardCodeBottomTextBold: 'Barcode not scanning?',
    giftCardCodeBottomBodyText: 'Enter the 30 digit number above manually at checkout',
    copy: 'COPY',
    christmasPopupGreet: 'Christmas is on us!',
    christmasPopupMessage: 'Congratulations, you\'ve got a £250 gift card to spend on whatever you like at M&S!',
    christmasPopupButton: 'See gift card',
    showVoucherButtonText: 'Show Christmas treat',
    showSparkscardButtonText: 'Show Sparks card',
    checkGCBalanceText: 'Check gift card balance',
    tsncs: 'Ts & Cs',
    congratulationsText: 'Congratulations!',
    christmasTreatText: 'HERE\'S YOUR SPARKS CHRISTMAS TREAT',
    checkGCBalanceURL: 'https://www.marksandspencer.com/c/gift-card-balance',
    addressCaptureBannerTitle: 'Want to check out faster?',
    addressCaptureBannerDesc: 'Add a default billing and shipping address so that next time you shop all you\'ll need to do is enter your card details',
    addressCaptureBannerCta: 'Add your address',
    addressSuccessBanner: 'Success! You\'ve saved an address',
    addresSuccessBannerDesc: 'You can review and update your details at any time by selecting \'Personal & Contact Details\' from the menu',
    addressSuccessBannerCta: 'See your account',
    myAccountLink: '/webapp/wcs/stores/servlet/MSMyAccountView?langId=-24&catalogId=10051&storeId=10151',
    addressCaptureExp: 'ADDRESS_CAPTURE',
    giftCardTsandCsProdLink: 'https://www.marksandspencer.com/c/help/legal-and-ethical-policies/what-are-the-gift-cardegift-card-terms-and-conditions',
    sfyNotificationPopupAgentGreet: 'YOU\'VE GOT A TREAT…',
    sfyNotificationPopupAgentMessage: 'You\'re this week\'s lucky Sparks customer and you\'ve got a big treat on us!',
    sfyNotificationPopupAgentButton: 'Verify customer',
    sfyNotificationPopupCustomerMessage: 'One of our customer support assistants will be in touch soon to discuss the treat with you in more detail.',
    sfyNotificationPopupCustomerSeperator: '- OR -',
    sfyNotificationPopupCustomerMessage2: 'Call us on ',
    sfyNotificationPopupCustomerMessage2a: '0333 014 8423',
    sfyNotificationPopupCustomerMessage3: 'Mon - Sun 8am - 8pm',
    sfyNotificationPopupCustomerButton: 'View your offers',
    sfyNotificationPopupCustomerVerifiedMessage: 'Your digital gift card is waiting for you in your hub. Enjoy a year of M&S shopping for free!',
    sfyNotificationPopupCustomerVerifiedButton: 'View digital gift card',
    shoppingForAYearQuestionText: 'Are you over 18?',
    shoppingForAYearTitle: 'CUSTOMER VERIFICATION',
    shoppingForAYearInstructionText: 'Can you tell me the last 10 digits of your Sparks card number',
    shoppingForAYearPopupButtonText: 'Submit',
    sfyVerifyFailMessage: 'This is not the card number linked to this account',
    cardInUseErrorKey: 'ONBOARD_SUBMIT_CARD_IN_USE',
    shoppingForAYearTryAgainButtonText: 'Try again',
    verifiedPopupAgentGreet: 'Verification success!',
    verifiedPopupAgentMessage: 'Customer has been verified.',
    verifiedPopupAgentButton: 'View your offers',
    sfyFailTitle: 'Sorry',
    errorFortarget: 'Sorry , we weren\'t able to load your balance',
    sfyFailBody: 'You are not eligible for this offer. This offer cannot be used if you are not 18 years old or above.',
    activateFailedMessage: 'Sorry, customer is verified but activation has failed. Please try again',
    referAFriendExp: 'REFER_A_FRIEND',
    referFriendTitle: 'REFER FRIENDS, EARN REWARDS',
    referFriendDesc: 'Invite your friends to join Sparks to earn more rewards you\'ll love',
    referFriendLink: 'Refer a friend now',
    referFriendPageTitle: 'REFER A FRIEND',
    referFriendPageDesc: 'Invite your friends to join Sparks and earn rewards you\'ll love',
    referFriendPageWorksTitle: 'How it Works',
    referFriendPageWorksShare: 'Share Sparks',
    referFriendPageWorksShop: 'They Shop',
    referFriendPageWorksEnjoy: 'Earn Rewards',
    referFriendPageWorksShareDesc: 'Share your unique referral link with up to five friends',
    referFriendPageWorksShopDesc: 'They\'ll get access to exciting new Sparks offers once they register',
    referFriendPageWorksEnjoyDesc: 'Once they\'ve shopped we\'ll send you a new Sparks reward to say thanks',
    rafLinkTitle: 'YOUR UNIQUE LINK',
    rafCopyCTA: 'Copy Link',
    rafFaceBook: 'SHARE',
    rafWhatsapp: 'MESSAGE',
    rafTwitter: 'TWEET',
    rafMail: 'GMAIL',
    rafPageTitleText: 'YOU\'VE BEEN REFERRED TO JOIN SPARKS',
    rafPageDescText: 'From big treats to little thank yous and a charity donation with every purchase',
    digitalReceiptsText: 'DIGITAL_RECEIPTS_JOURNEY',
    digitalReceiptsTitle: 'Go digital',
    digitalReceiptsDescription: 'Tired of losing receipts? Go digital and we\'ll email your receipts for in-store purchases straight to your inbox. Fast, easy and convenient.',
    digitalReceiptsToggleOff: 'Switch on digital receipts',
    digitalReceiptsToggleOn: 'Great! You\'ll now receive digital receipts',
    eReceiptExp: 'ERECEIPTS',
    ereceiptErrorMessage: 'Something went wrong, please try again.',
    sparksConsentTitle: 'You\'re missing out',
    sparksConsentTitleSuccess: 'Success!',
    sparksConsentDescription: 'Don\'t miss out on personalised offers, treats and surprises from Sparks, including the chance to get your shopping for free!',
    sparksConsentDescriptionSuccess: 'Thanks for signing up to Sparks. You\'ll now receive rewards, offers, treats and surprises, just for you.',
    sparksConsentToggleOff: 'Sign up for Sparks',
    sparksConsentToggleOn: 'You\'re all set',
    sparksConsentExp: 'SPARKS_EMAIL',
    tgtExpErrorMessage: 'Something went wrong, please try again.',
    marketConsentTitle: 'Never miss a thing',
    marketConsentDescription: 'We will send you exclusive offers, rewards, promotions and news via email and/or text about our products and services and those offered by our partners. If you change your mind. You can opt out any time.',
    marketConsentDescriptionSuccess: 'Thanks for subscribing. You can opt out at any time by changing your preferences.',
    marketConsentToggleOff: 'Subscribe',
    marketConsentExp: 'MARKETING_EMAIL',
    viewStreakButtonText: 'See your stamps',
    activateStreakButtonText: 'Start earning',
    howToEarnText: 'Full details',
    streakTitle: 'Earn a FREE ',
    activeStreakTextPart1: 'Buy ',
    activeStreakTextPart2: ' more to get a FREE ',
    activeVisitStreakText: 'BALANCE stamps away from <b>SAVE</b> off your next shop',
    streakHeader: 'Save with Sparks',
    streakTarget: 4,
    mockBalance: '1.00',
    streakOfferStamp1Greet: 'You\'ve earned<BR> your first stamp!',
    streakOfferStamp1Greet2: 'You\'re off to a great start.<BR> Buy <b>3</b> more to get your <b>FREE</b> ',
    streakOfferStamp1ButtonText1: 'See your progress',
    streakOfferStamp1URL: 'Full details',
    streakOfferCompleteGreet: 'You\'ve earned <BR><b>a FREE </b>',
    streakOfferCompleteGreet2: 'Next time you\'re in store scan your preferred <offername> and Sparks card - it\'s on us!',
    streakOfferCompleteButtonText: 'View your reward',
    streakOfferCompleteURL: 'Full details',
    qrTreatNotificationTitle: 'Just for you',
    qrTreatNotificationMessage: 'To claim your treat, sign in or register with Sparks',
    qrTreatNotificationButton: 'Go to Sparks',
    treatCampaign: 'qrcode_generic',
    confirmAddressText: 'Confirm address',
    addressWCSErrMsg: 'Something went wrong, Please try after sometime',
    referralPageDesc: 'Share your unique referral link with friends, they\'ll get exciting new Sparks offers once registered, and you\'ll get a new reward once they shopped.',
    rafTreatNotificationTitle: 'CONGRATULATIONS',
    rafTreatNotificationMessage: 'Your friend has joined Sparks, you have a new reward waiting in your Sparks hub',
    rafTreatNotificationButton: 'Check your offers',
    referralTandC: 'Full Ts&Cs can be ',
    referralTandCLink: 'found here.',
    referralTandCHref: 'https://www.marksandspencer.com/c/help/legal-and-ethical-policies/sparks-benefits-terms-and-conditions',
    referralFandQ: 'Click ',
    referralforFandQ: 'for FAQs',
    referralFandQLink: 'here',
    referralFandQHref: 'https://www.marksandspencer.com/c/help/sparks-refer-a-friend',
    qrcodePageDesc: 'Scan QR and get new exciting new Sparks offers and new reward.',
    qrCodeErrMsg: 'Something went wrong',
    sasFirstPurchaseGreet1: 'You\'re on your way<BR> to £<save> off',
    sasFirstPurchaseGreet2: 'Well done, you\'re closer to earning £<save> off your next shop. Spend £<spend> on <offername> in store to earn your reward',
    sasFirstPurchaseButtonText: 'See your progress',
    sasFirstPurchaseURL: 'Full details',
    streakSASActivatedSpent: 'SPENT',
    streakSASActivatedCardText: 'Spend £<remainder> more to receive your £<save> reward',
    streakSASOfferCompleteGreet: 'You\'ve earned <BR><b><save> off your next shop</b>',
    streakSASOfferCompleteGreet2: 'Add your reward and it\'ll be automatically applied when you next scan your card at the till in store',
    streakSASOfferCompleteButtonText: 'Add reward to Sparks card',
    streakSASOfferCompleteURL: 'Full details',
    bankTreatPopUpTitle: 'CONGRATULATIONS',
    bankTreatPopUpMessage: 'You\'ve received a special treat and two welcome offers from Sparks. Sign up now to view your treat, redeem your offers and access more Sparks benefits you\'ll love. Happy shopping!',
    registerGenericCampaign: '/webapp/wcs/stores/servlet/MSResUserRegistration?catalogId=10051&myAcctMain=1&langId=-24&storeId=10151',
    carouselTitlePattern: 'Women|women',
    carouselPattern: 'offersPageComponent',
    mnsOffersTitle: 'M&S discounts and Promotions',
    throttle: {
        mnsOfferThrottle: 10
    },
    assistanceTitle: 'Assistance',
    assistanceAccount: 'Your account',
    assistanceFaq: 'FAQs',
    assistanceSparks: 'How to use Sparks',
    assistanceCardLink: 'Link my physical card',
    assistancePreference: 'Marketing preferences',
    yourAccountUrl: '/webapp/wcs/stores/servlet/MSMyAccountView?catalogId=10051&myAcctMain=1&langId=-24&storeId=10151',
    faqsUrl: '/c/help/sparks',
    aboutUrl: '/mysparks/about',
    marketingPreferencesUrl: '/preferences',
    appOnlyOfferTitle: 'EXCLUSIVE APP OFFER',
    appOnlyOfferTextAppend: '. Only in the M&S app',
    appDownloadExp:'APP_DOWNLOAD',
    winnerPopupTitle: 'CONGRATULATIONS',
    winnerPopupMsg: 'You’ve just won your M&S food shop for free with Sparks!',
    winnerPopupBtn: 'View your offers',
    winnerPopupAmt: '£55.50',
    winnerFaceBook: 'SHARE',
    winnerTwitter: 'TWEET',
    winnerShareTitle:'SHARE IT',
    eReceiptPageContentText: 'Opt in to email receipts now to save paper and do away with lost or damaged printed receipts.',
    eReceiptPageContentDesc: 'We\'ll send your receipt to the email you signed up with, and always save a copy in the M&S app.',
    eReceiptOptinText: 'Opt in to email receipts',
    eReceiptOptinSuccessMsg: 'Your Digital Receipts preferences have been saved successfully',
    eReceiptPageCtaText: 'Save',
    eReceiptSuccessMsg: 'Your Digital Receipts preferences have been saved successfully',
    emailTriggerErrMsg: 'Something went wrong, Please check after sometime',
    captureDateOfBirth: 'DOB_CAPTURE',
    captureDobTitle: 'Have you added your date of birth?',
    captureDobMsg: 'Want a more personalised Sparks experience? Let us know your date of birth.',
    captureDobBtn: 'Update',
    captureDobErr: 'Please enter a valid date',
    captureDobSuccessTitle: 'You\'ve added your date of birth!',
    capturDobeSuccess: 'You\'ve successfully added your date of birth. Review your account at any time',
    accountTextDobCta: 'Your account',
    eReceiptOptinLabel: 'Opt in to email receipts',
    eReceiptPageLink: '/mysparks/eReceipt',
    eReceiptPopupLink: '/mysparks/eReceipt#intid=sparks_hub_popup_digital-receipts-never-lose-a-receipt-again',
    qrToolLink: '/mysparks/qrtool',
    eReceiptSubText: 'Email receipts can be used for refunds, returns and exchanges. Please note, receipt emails may contain additional marketing content.',
    eReceiptPagePref: 'Visit <pref_location> to change your email preferences.',
    eReceiptPageTerms: 'Terms & Conditions',
    eReceiptPageAgree: '*If you\'ve agreed to the use of cookies and/or to receive marketing communications, you have the right to withdraw your consent at any time.',
    eReceiptPagePolicy: 'Please see our <data_location> for more information',
    eReceiptPrefHref: '/preferences',
    eReceiptTermsHref: '/c/help/legal-and-ethical-policies/what-are-the-websites-terms-and-conditions',
    eReceiptPolicyHref: '/c/data-protection-policy',
    sasTitle: 'Skip the queue with Scan & shop',
    sasDesc: 'Never queue again with Scan & Shop. Simply use your phone to scan and bag items as you go, then pay for your food shop directly from the M&S app',
    sasAppTitle: 'Open the M&S app',
    sasAppDesc: 'Tap the \'More\' button on an iPhone or the \'Menu\' button on an Android',
    sasShopTitle: 'Scan & Shop',
    sasShopDesc: 'Scan the barcode on each item using your phone. Bag as you go',
    sasPayTitle: 'Pay for your shop',
    sasPayDesc: 'Simply pay from the app using your card, Apple Pay or Google Pay',
    yourSparks: 'Even more with Sparks',
    thumbnailsScanTitle: 'Scan & Shop',
    thumbnailsScanDesc: 'Never queue at the checkout again with Scan & Shop',
    thumbnailsLiveTitle: 'Virtual events',
    thumbnailsLiveDesc: 'Sign up to our virtual events and explore past ones',
    thumbnailsReciptTitle: 'Digital receipts',
    thumbnailsReciptDesc: 'Receive email receipts for transactions made in-store',
    scanAndShopUrl: 'https://www.marksandspencer.com/c/scan-and-shop',
    sparkLiveUrl: 'https://sparkslive.marksandspencer.com/events-archive',
    digitalErecipt: 'https://www.marksandspencer.com/MSRetrieveDigitalReceiptsPrefCmd?catalogId=10051&errorViewName=MSMyAccountView&langId=-24&storeId=10151&intid=sparks_thumbnail',
    enableInfobox: true,
    joinSparksUrl: 'https://www.marksandspencer.com/joinsparks',
    freeDeliveryTitle:'FREE DELIVERY PASS',
    nddWineGiftsCopy: 'Get FREE next-day delivery on food gifts and wine orders for 90 days',
    nddAllCopy: 'Get FREE next-day delivery on clothing, home, gifts & wine until 23rd Dec',
    nddChCopy: 'Get FREE next-day delivery on clothing and homeware orders until 23rd Dec',
    stndChCopy: 'Get FREE standard delivery on clothing and homeware orders for 90 days',
    freeDeliveryBannerC: 'FREE_DELIVERY_PASS',
    deliveryPass1: 'NDD_WINE_GIFTS',
    deliveryPass2: 'NDD_ALL',
    deliveryPass3: 'NDD_CH',
    deliveryPass4: 'STND_CH',
    addDeliveryPass: 'Add Delivery Pass',
    deliveryPassAdded: 'Delivery Pass Added',
    accountToggleText: 'Account',
    welcomeReskinText: 'Welcome to Sparks,',
    welcomeSparksPlusText: 'Welcome to Sparks Plus,',
    scanAppDownTitle: 'How to get started',
    scanAppDownDesc: 'Download the M&S app on iOS or Android and experience the new way to shop.',
    scanReviewDesc: '“I was able to buy lunch in under 40 seconds – in fact, it was more like 15 seconds.”',
    scanReviewName: '- Sam Richardson',
    classNameIdentifer: 'uk',
    scanAccordionTitle: 'Frequently asked questions',
    scanAccodianData: {
        'id': 'accordion-1',
        'accordionSections': [
            {
                'label': 'Can I use Scan & Shop in all M&S stores?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'Scan & Shop Mobile App is available in all M&S owned food stores. Excludes M&S Simply Food Franchise stores at Service stations, Railway stations, Hospitals and Airports. In selected stores, you can also use one of our in-store Scan & Shop devices while shopping'
                }
            },
            {
                'label': 'Does Scan & Shop App work on all devices?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'The Scan & Shop App works on devices running iOS 10 (or a later version of iOS) or Android 4.4 (or a later version of Android).'
                }
            },
            {
                'label': 'Do I need to have a Sparks account to use Scan & Shop?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'Yes, Scan & Shop is an exclusive feature available to Sparks customers, along with many other tailored offers, rewards and promotions that Sparks has to offer.'
                }
            },
            {
                'label': 'Can I use Scan & Shop on Clothing and Home products?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'No, currently this is only available for food products'
                }
            },
            {
                'label': 'What if I have issues when using Scan & Shop App?',
                'contentPartial': 'sparks/sparks-accordion/badge',
                'content': {
                    'text': 'If you are struggling to connect to the app check the below tips to ensure you are good to go!.<BR> <strong>1.Poor cellular connection </strong> - why not try and connect to the free M&S instore Wi-Fi.<BR> <strong>2.Location permissions</strong> - ensure you have allowed access to your location as we need to detect which store you are in while using the feature (only while using the app).<BR> <strong>3.Camera permissions</strong> - ensure you have allowed access to your camera to enable the device to scan product barcodes (only while using the app).<BR> <strong>4.Latest app version </strong> - check you are up to date with the latest version in the Apple/Google Play store.If you are still having issues, or the issue relates to one of our in-store Scan & Shop devices, speak to one of our colleagues who will be happy to help you.'
                }
            },
            {
                'label': 'Do I need to scan every item?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'Yes, including ‘Buy one, get one free’ items and multibuys to ensure discounts are applied and you pay the right price'
                }
            },
            {
                'label': 'Do I need to go to a till?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'No queuing, no tills. Simply scan the products as you shop and put them straight in your bag. Pay on your device using your registered payment method before leaving the store.'
                }
            },
            {
                'label': 'Is there anything I can’t buy with the Scan & Shop App?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'Currently we cannot sell the following items with the Scan & Shop App, alcohol and other age-restricted products, medicines, If you wish to purchase these items please take them to a till or self service till'
                }
            },
            {
                'label': 'Are there any limits to Scan & Shop',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'Yes, currently the minimum spent on the app is 30p and maximum is £45*. If you wish to purchase items outside of these limits, simply take the items to a till. *In selected stores alternatively, you can transfer your shopping basket by scanning a QR code at a dedicated Scan & Shop till (Kew & Cribbs Causeway) and complete your transaction at a till with no restrictions.'
                }
            },
            {
                'label': 'How do I scan products that don’t have barcodes?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'For bakery items simply scan the barcode on the shelf ticket or type in the 3 digit code. For loose fruit and veg use the scales provided near self service tills to print a ticket and scan the barcode or type in the 3 digit code on the shelf ticket.'
                }
            },
            {
                'label': 'What do I do if the product does not scan?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'If any item does not scan, you can type in the 8 digit product code on the barcode or it may mean you are not able to purchase that item in the app and a prompt will appear to indicate this. Please go to a normal till to purchase these items.'
                }
            },
            {
                'label': 'How do I scan products that don’t have barcodes?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'For bakery items simply scan the barcode on the shelf ticket or type in the 3 digit code. For loose fruit and veg use the scales provided near self service tills to print a ticket and scan the barcode or type in the 3 digit code on the shelf ticket.'
                }
            },
            {
                'label': 'Can I use my own bags?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'You can edit items in the basket screen using the ‘+’ or ‘-‘ toggles on the item or swipe left to remove the item from your basket.'
                }
            },
            {
                'label': 'Can I use vouchers, gift cards or e-gift cards?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'No, currently we can’t accept them through the Scan & Shop App, please pay at a normal till to use these.'
                }
            },
            {
                'label': 'Where is my receipt?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'This is displayed after purchase and can be viewed again by visiting the menu in the top right of the Scan & Shop screen and tapping on Shopping History'
                }
            }
        ]
    },
    checkMailOnAcc: 'We\'ve sent you a new email',
    emailCheckAcc: 'Can\'t see it? Check your junk mail or click below to resend',
    adventOnlyType: 'ADVENTCALENDAR',
    sparksAppTitle: 'Your Sparks card and benefits are also digital',
    sparksAppDesc: 'Download the M&S app to scan your card straight from your phone, and keep track of offers and rewards.',
    sparksAppMobDesc: 'Download the M&S app to scan your card straight from your phone, and keep track of offers and rewards.',
    adventOfferTitle: 'YOUR CHRISTMAS REWARDS',
    addedOfferTitle: 'YOUR ADDED OFFERS',
    deliverypassUrl: 'https://www.marksandspencer.com/c/help/legal-and-ethical-policies/sparks-benefits-terms-and-conditions#DELIVERYPASS',
    charityPromptExp: {
        expName: 'CHARITY_PROMPT',
        title: 'Select your charity and we\'ll donate every time you shop',
        btnValue: 'Okay'
    },
    welcomeOfferPromptExp: {
        expName: 'WELCOME_OFFER_PROMPT',
        title: 'Activate your Sparks<BR>before you shop',
        btnValue: 'Okay'
    },
    scanAndShopAppDownload: 'https://mandsapp.onelink.me/256943915/c46e9c72',
    appDownloadElement: 'https://mandsapp.onelink.me/256943915/6c4104a9',
    receiptsPromptExp: {
        expName: 'ERECEIPT_PROMPT',
        title: 'View your receipts<br>here',
        btnValue: 'Okay'
    },
    adventStoreButtonText: 'Open Now',
    adventPartnerOffers: {
        offerIds: [19066, 19067, 19068, 19069, 19070] //eslint-disable-line no-magic-numbers
    },
    myRewardsLink: '/mysparks/myrewards',
    myRewardsLinkingJourneyLink : '/digitalrewards/join',
    myRewardVouchersLink: '/mysparks/myrewards/vouchers',
    digitalRewardVouchers: {
        title: 'REWARDS VOUCHERS',
        description1: 'For you to spend at M&S',
        description2: 'Redeem your Rewards vouchers in store with the app or when you pay online',
        description3: 'You can your voucher codes in store. If you’re shopping online, lorum impsum about whether or not we can surface these at checkout for them.',
        description4: 'Your voucher codes will automatically be available to select at the checkout.',
        termsAndCondTitle: 'TERMS AND CONDITIONS',
        termsAndConditions: 'Valid in Marks & Spencer stores in the UK and Channel Islands (excluding BP Connect stores and Applegreen stores) and online at marksandspencer.com. These locations may be extended at our discretion. Vouchers may only be redeemed against Marks & Spencer products and services except Marks & Spencer gift cards, Travel Money or cash advances. Vouchers cannot be redeemed against M&S Bank products. We reserve the right to substitute or remove product ranges / services / offers available for redemption at any time. One or many vouchers can be redeemed in a single transaction and must be surrendered upon redemption. Each voucher can only be redeemed once either in store or online. No change will be given against vouchers. Purchases paid in for in part using M&S reward vouchers do not qualify for bonus points, except when the spend on the M&S Card exceeds any applicable bonus offer threshold spend. Marks & Spencer cannot be held responsible for vouchers once they have left its control. Marks & Spencer reserves the right to reject this voucher with reasonable cause. Only original vouchers can be accepted. This voucher is issued under the terms and conditions of the M&S Loyalty Scheme.<br><br>General terms and conditions: The issue of M&S reward vouchers is subject to a minimum number of points being collected. Reward vouchers are always issued in whole £ denominations. Full details can be found in the M&S Loyalty Scheme terms and conditions. The M&S Loyalty Scheme is promoted and operated by Marks and Spencer plc. The reproduction of colours is as accurate as photographic and printing processes will allow. All correspondence to be addressed to Customer Services department (Loyalty Queries), Kings Meadow, Chester CH99 9FU. Marks and Spencer plc. Registered Office: Waterside House, 35 North Wharf Road, London W2 1NW. Registered number: 214436 (England and Wales). ©Marks and Spencer plc. Marks & Spencer and Your M&S are registered trademarks of Marks and Spencer plc and are used under license.',
        noVoucherMessage: 'Earn rewards points when you spend on your M&S Credit Card and they’ll be converted in to M&S vouchers.',
        noStatementMessage: 'Once your points have been converted into vouchers, your statements will appear here.',
        noPointsAndQrm: 'Start earning points and you’ll be able to see them here.',
        rewardsAppLink: 'To redeem your Rewards in store, you’ll need <a href="https://www.marksandspencer.com/c/mobile-apps">the M&S app</a>.',
        drAppleLink: 'https://mandsapp.onelink.me/256943915/c9e7da17',
        drGooglePlayLink:'https://mandsapp.onelink.me/256943915/AndroidSparksOffer',
        emptyVoucherText1: 'No Rewards vouchers',
        emptyVoucherText2: 'Earn Rewards points with M&S Credit Card spend'
    },
    digitalRewardsOffer: {
        BonusOffer: {
            title: 'BONUS OFFER'
        }
    },
    linkingJourney: {
        step1: 'Begin sign-up',
        step2: 'Confirm details',
        step3: 'Success',
        landing: {
            topic: 'Let’s get started',
            subtopic: 'Access your Rewards vouchers and offers conveniently in one place, by linking your Sparks account to your Credit Card account at M&S.com or in the M&S app',
            heading1: 'Everything in one place',
            heading2: 'Flexibility at your fingertips',
            heading3: 'Never miss a thing',
            text1: 'Access your Credit Card Rewards and Sparks offers in one place, at your fingertips, any time - at home or on the go, with no need to keep track of paper vouchers',
            text2: 'Access to your Rewards, whenever you want them - through the M&S app on your phone or when you shop with us online',
            text3: 'Keep track of all your Rewards easily with handy reminders when your offers and Rewards are ready to use',
            bottomText1: 'M&S Credit Card Rewards allows you to access your Rewards vouchers and Bonus Offers in your Sparks Account. If you don’t have Sparks you can sign up when registering. You’ll also need to know your M&S Bank details.',
            bottomText2: 'To redeem your Rewards in store, you’ll need <a href="https://www.marksandspencer.com/c/mobile-apps#intid=spanav_rewards-lp_txt_mands-app" target="_blank" rel="noopener">the M&S app</a>. Simply scan the barcodes at the till.',
            bottomText3: 'You may need to update your mobile phone’s operating system to run the M&S app. You may need to update to the latest version of the M&S app. For more information on how we process your data, please refer to the'

        },
        gettingStarted: {
            title: 'To get started',
            subTitle: 'You’ll need to link your credit card account. Please have the following ready.',
            text1: 'M&S sign in information',
            text2: 'M&S Bank username and security code generator',
            text3: 'Please allow 2-5 minutes to link your accounts'
        },
        permissions: {
            title: 'To link your M&S Credit Card Rewards, we’ll need you to confirm your account details with M&S Bank',
            subTitle: 'You’ll need to be registered for Internet Banking at M&S Bank. To register click <a href="https://bank.marksandspencer.com/internet-banking/how-to-register/" target="_blank" rel="noopener">here</a>.<div style="padding-top: 15px;"></div> We can help if you’ve forgotten your details. Please click <a href="https://bank.marksandspencer.com/internet-banking/forgotten-details/" target="_blank" rel="noopener">here</a>'
        },
        success: {
            title: 'Success !',
            subTitle: ' Your M&S Credit Card Rewards are available in your Sparks account',
            btnSparks: 'Go to Sparks',
            basket: 'To redeem your Rewards in store, you’ll need the M&S app.  Simply scan the barcodes at the till',
            mobile: 'Use your Rewards online by selecting them when you pay'
        },
        error: {
            title: 'Sorry',
            subTitle: 'There was an issue linking your account. Please try again',
            backBtn: 'Try again',
            callUs: 'If the issue continues to be a problem, call us on 0345 900 0900.'
        }
    },
    genericAppOnlyTitle: 'Exclusive app offer',
    genericAppOnlyText: 'You have an offer on the app. Download that app and treat yourself',
    genericAppDownloadBanner: 'https://mandsapp.onelink.me/256943915/efbb34d1',
    registerFromAboutLink: '/webapp/wcs/stores/servlet/MSResUserRegistration?catalogId=10051&myAcctMain=1&langId=-24&storeId=10151&isSparksRelaunch=Y&intid=sparksnav_landing_register_about',
    signInFromAboutLinkPart1: '/webapp/wcs/stores/servlet/MSResLogin?catalogId=10051&langId=-24&storeId=10151&isSparksRelaunch=Y&rememberMe=true&WcUseHttps=true&viewTaskName=RedirectView&intid=sparksnav_landing_signin_about',
    signInFromAboutLinkPart2: '/mysparks',
    marchSparksAppTitleOne: 'THE BIG',
    marchSparksAppTitleTwo: 'SPARKS GIVEAWAY',
    genericAppOnlyOffer: 'OFFER_APPONLY',
    anchorLinkTermsConditions: 'Read complete terms & conditions',
    charityBannerTitle: 'THIS MONTH',
    charityBannerMessage: 'We are doubling your charity donation every time you shop*',
    marchLoveFooterNote: '*For every transaction you make where you scan your Sparks card or are logged in to M&S with your Sparks account, M&S will donate 2p to charity.',
    profileCompletionTitle: 'YOUR SPARKS PROFILE STATUS',
    profileCompletionDesc: 'Complete your profile to get the most out of Sparks PLUS £5 off in the app',
    profileCompletionDismissDesc: 'Complete your profile to get the most out of Sparks',
    profileCompletionBtn: 'Complete now',
    paidDeliveryOffer: 'OFFER_PAIDDELIVERY',
    paidDeliveryBanner: 'BANNER_PAIDDELIVERY',
    sparksPayRedirectParam: 'redirectTo=sparkspay',
    sparksPayRedirectUrl: '/sparkspay/apply',
    sparksRewardsLinkingRedirectParam: 'redirectTo=sparksRewardsLinking',
    sparksRewardsLinkingRedirectUrl: '/digitalrewards/join',
    sparksRewardsLinkingLanding: '/digitalrewards/join?step=landing',
    countdownBannerType: 'BANNER_COUNTDOWN',
    charityUnicefNote: 'Donations to UNICEF UK are split equally between their new <a href="https://www.unicef.org.uk/donate/syria-turkiye-earthquake/" target="_blank">Earthquakes appeal</a> and their ongoing <a href="https://www.unicef.org.uk/donate/donate-now-to-protect-children-in-ukraine/" target="_blank">Ukraine appeal</a>. These funds enable UNICEF to deliver its emergency response and ensure that children have access to clean drinking water, protection services, critical health supplies, winter blankets, and other resources.',
    charityOxfamNote: 'Sparks donations currently help the Turkey and Syria Earthquake Appeal. Oxfam are providing food, water, shelter, and sanitation in both Turkey and Syria, using local teams and a network of partners in each country. You can find out more about their emergency appeal <a href="https://www.oxfam.org.uk/oxfam-in-action/current-emergencies/turkey-and-syria-earthquake-appeal/" target="_blank">here</a>.',
    instantWinBannerTitle: 'Can you guess?',
    instantWinBannerDesc: 'See how much FREE shopping UK Sparks customers won last month.',
    profileText: 'Complete your profile',
    profileDescription:'From charity donations to faster checkout, complete your profile to get the most of Sparks ',
    profileDescComp: 'You\'re all set! Click \'Claim offer\' and then check your M&S app to see your offer.',
    profileDesCompDismiss: 'You\'ve added your offer. See it now and shop in the M&S app.',
    profileDescDismiss: 'You\'re all set! You can edit your details at any time.',
    profileCharityLink:'/mysparks/mycharity',
    profileDobLink: '/MSAccountProfileDisplayView',
    profileAddressLink: '/MSAccountProfileDisplayView',
    profileCharityText: 'Select Charity',
    profileDobText: 'Provide date of birth',
    profileAddressText: 'Provide address',
    paidDeliveryProductDetail:{
        title: 'SAY GOODBYE TO DELIVERY CHARGES',
        subTitle: 'M&S delivery pass benefits:',
        descriptionOnePartOne: 'A whole year',
        descriptionOnePartTwo: 'of unlimited standard and next-day delivery',
        descriptionTwoPartOne: 'Sending a gift?',
        descriptionTwoPartTwo: 'We\'ll deliver to your door or direct to a friend',
        descriptionThreePartOne: '1 year pass:',
        descriptionThreePartTwo: '£25',
        buttonText: 'Add to bag',
        tnc: 'Please note, you\'ll need to purchase your delivery pass before it\'s applied to your orders. Items bought at the same time won\'t get automatic free delivery.',
        tncBlockText: 'Full terms and conditions',
        tncUrl: 'https://www.marksandspencer.com/c/help/legal-and-ethical-policies/sparks-benefits-terms-and-conditions',
        addToBagUrl: '/webapp/wcs/stores/servlet/AjaxOrderItemAddCmd',
        addToBagParams: 'productId=P60573131&storeId=10151&catalogId=10051&partNumber_1=60573131&quantity_1=1',
        checkoutPageUrl: '/OrderCalculate?calculationUsageIdentifier=MSBasketView_ShoppingCartURL&updatePrices=1&errorViewName=AjaxOrderItemDisplayView&orderId=.&langId=-24&doPrice=Y&URL=AjaxOrderItemDisplayView&storeId=10151&catalogId=10051',
        warningText: 'Something\'s wrong; please try adding to bag again',
        errorText: 'Unable to add to bag; please try refreshing the page',
        maxRetryCounter: 3,
        productId: 'P60573131',
        productName: 'Paid Delivery',
        productStroke: '8811X',
        productPrice: '25.00',
        productUpc: '27784471',
        maxQuantityErrorCode: '_ERR_MAX_QTY_ORDER_ITEM_ADD',
        maxQuantityErrorMessage: 'Sorry, this item is limited to one per customer',
        deliveryPassSection: '#DELIVERYPASS',
        cookieName: 'cancelMembership',
        cookieTimeOutMinutes: 2,
        offerId: 16406,
        cancelSuccessMessage: 'Your cancellation request is being processed.',
        cancelErrorMessage: 'Something went wrong, please try again.',
        topBannerTitle: 'Unlimited Delivery for just <b>£25</b> a year',
        topBannerSubTitle: 'Say goodbye to delivery charges',
        topBannerIconOneTitle: 'Unlimited delivery ',
        topBannerIconOneDesc: 'Every time you shop online with us ',
        topBannerIconTwoTitle: 'Standard and next-day delivery ',
        topBannerIconTwoDesc: 'Incredible savings on deliveries including free returns ',
        topBannerIconThreeTitle: 'Send a gift',
        topBannerIconThreeDesc: 'We’ll deliver to your door or direct to your friend',
        topBannerIconFourTitle: 'No minimum spend',
        topBannerIconFourDesc: 'You can order as many items as you want',
        deliveryPassTableMidTitle: 'Unlimited delivery and free returns for just £25 a year',
        faqTitle: 'Sparks Delivery Pass frequently asked questions',
        faqs: {
            id: 'acc-delivery-pass',
            accordionSections: [
                {
                    'label': 'When will my pass be activated?',
                    'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                    'content': {
                        'text': 'Your delivery pass should be activated in your Sparks account within an hour of you buying it. We have you covered – your first order will be delivered free of charge while you wait for your delivery pass. If your delivery pass hasn’t been activated within 24 hours, please contact our customer service team.'
                    }
                },
                {
                    'label': 'Will I receive free delivery on all M&S items?',
                    'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                    'content': {
                        'text': 'You’ll get free delivery with most M&S items online. The exceptions are furniture, made-to-measure suits, Your School Uniform, Christmas Food to Order, cakes for collection, e-gift cards and anything ordered through Ocado.'
                    }
                },
                {
                    'label': 'Will my delivery pass be auto-renewed?',
                    'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                    'content': {
                        'text': 'We won’t renew your delivery pass without your permission. We’ll contact you about your renewal so you can decide what you’d like to do.'
                    }
                },
                {
                    'label': 'Which delivery options are included with my delivery pass?',
                    'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                    'content': {
                        'text': 'Your delivery pass entitles you to free standard, next-day and nominated-day delivery.'
                    }
                }
            ]
        },
        deliveryPassTableTitle: 'Breakdown of savings',
        deliveryPassTableNote: 'Based on UK next-day delivery price of £5.99. No minimum spend',
        deliveryPassTableHeadingOne: 'Orders per year',
        deliveryPassTableHeadingTwo: 'Without delivery pass',
        deliveryPassTableHeadingThree: 'With delivery pass',
        deliveryPassTable: [
            {
                dataOne: '5',
                dataThree: 'Save',
                dataFour: '£4.95'
            },
            {
                dataOne: '10',
                dataThree: 'Save',
                dataFour: '£34.90'
            },
            {
                dataOne: '15',
                dataThree: 'Save',
                dataFour: '£64.85'
            }
        ],
        deliveryPassCancelMaxDaysToShow: 14,
        deliveryPassPageUrl: '/mysparks/deliverypass?storeId=10151&catalogId=10051',
        deliveryPassRetentionPageUrl: '/mysparks/deliverypass/renew?storeId=10151&catalogId=10051',
        postPurchaseRetentionAnalytics: 'spa_hub_bnr_delivery-pass-expires-soon',
        sparksPlusLinkText: 'Click to view the Delivery Pass details',
        analyticsTag: 'sparks_hub_bnr_paid-delivery_find-out-more_mid_btn',
        deliveryPassRenew : {
            title: 'Delivery pass',
            subTitle: 'Enjoy <b>unlimited</b> delivery for just <b>£25</b> a year, as well as <b>free returns</b>',
            buttonText: 'Renew your pass',
            note: 'Don’t worry – you won’t lose the days you’ve got left by renewing your delivery pass early',
            preTitle: 'It looks like you don’t have a delivery pass yet',
            preSubtitle: 'Get unlimited delivery for just £25 a year',
            postTitle: 'Your delivery pass',
            benefits: 'Benefits',
            renewalDaysCount: 30,
            viewSubscription: 'View subscription',
            nonTargetedHeadingOne: 'Sparks Delivery Pass trial',
            nonTargetedHeadingTwo: 'Our Delivery Pass is still being trialled with a limited number of customers. We’re working towards rolling it out to more and more customers, so keep your eyes peeled – a year’s unlimited delivery could soon be yours.'
        }
    },
    profileCompletionReward: 'Claim offer',
    profileCompletionDismiss: 'Dismiss',
    profileCompletionStages: 3,
    paidDeliveryPostPurchaseTerms: 'Terms & conditions',
    paidDeliveryPostPurchaseCancel: 'You can cancel the pass if you haven’t used it within 14 days of purchasing',
    profileComponentAnalyticsArray: ['#intid=sparks_hub_flyout_complete-your-profile_charity', '#intid=sparks_hub_flyout_complete-your-profile_address', '#intid=sparks_hub_flyout_complete-your-profile_dob'],
    sparksPlusBanner:{
        type: 'BANNER_SPARKS_PLUS',
        analyticsTag: 'spa_hub_bnr_sparksplus-find-out-more_mid_btn'
    },
    removeOfferDesc: 'Thanks for the feedback!',
    offerInteractionConfirmButton: 'Dismiss',
    ereceiptheader:'Your past receipts',
    eReceiptLoadmoreCta:'Load more',
    noreceiptHeader:'You don’t have any digital receipts yet',
    noreceiptBody:'Your digital receipts will now appear here when you shop in store and scan your Sparks card',
    pageSectionTitle: 'Sparks offers',
    maneProjectTitle: 'Win 1000s of Prizes',
    maneProjectText: 'Win M&S prizes or a football masterclass for U18s with their national team',
    maneProjectBtn: 'Enter or check progress',
    maneProject: 'SPARKS-COMPETITION',
    sparksPlusOffer: 'OFFER_SPARKS_PLUS',
    maneBannerCTA: '/football#intid=spa_hub_bnr_eatwell-comp-enter-now',
    maneProjectEndTitle:'COMPETITION CLOSED',
    maneProjectEndText:'Thanks for participating in our Eat Well competition! ',
    maneProjectEndSubText:'Please check back between 1-18 October to see if you’ve won a prize!',
    welcomeJourneyType: 'WELCOME_NEW_CUST_JOURNEY',
    sparksPlusProductDetail:{
        title: 'Get the VIP treatment every time you shop',
        subTitlePartOne: '£120 for a 12 month subscription (enjoy perks worth over £200)',
        subTitlePartTwo: 'Equal to £10 a month  |  ',
        subTitlePartThree: '30-day money-back guarantee',
        subTitlePartFour: 'Learn more',
        buttonText: 'Get the VIP treatment',
        note: '',
        howSparksWorks: {
            titleOne: 'Join',
            descOne: 'Want the VIP treatment every time you shop? Sign up to a Sparks Plus 12 month subscription for £120 <br/><br/>(30-day money-back guarantee)',
            titleTwo: 'Benefit',
            descTwo: 'You’ll get exclusive rewards and treats on the things you love',
            titleThree: 'Redeem',
            descThree: 'Keep track of your vouchers, exclusive rewards, and offers in your M&S Sparks account'
        },
        topSectionIcons: {
            oneTitle: 'Monthly £10 voucher',
            oneDesc: 'To spend on all your M&S favourites',
            twoTitle: 'Unlimited next-day delivery',
            twoDesc: 'Every time you shop online with us',
            threeTitle: 'Monthly hot drink on us',
            threeDesc: 'Enjoy a free tea, coffee or hot drink every month in our café',
            fourTitle: 'Exclusive benefits and perks',
            fourDesc: 'Get exclusive Sparks Plus benefits with your subscription'
        },
        vipSection: {
            titlePartOne: 'More VIPs',
            titlePartTwo: '(Very Important Perks)',
            subTitle: 'These are included, too',
            iconOneDesc: 'Be amongst the first to try the best of M&S and have your voice heard',
            iconTwoDesc: 'A special gift from Sparks Plus',
            iconThreeDesc: 'Invites to instore events',
            iconFourDesc: 'Double charity donations when you shop with Sparks Plus',
            iconFiveDesc: 'Plus get all the regular Sparks benefits!'
        },
        sparksPlusTableTitle: 'Get more with Sparks Plus',
        sparksPlusTable: [{
            description: 'Personalised offers',
            sparks: true,
            sparksPlus: true,
            doubleTick: false,
            className: 'odd'
        },
        {
            description: 'Little thank yous and treats',
            sparks: true,
            sparksPlus: true,
            doubleTick: false,
            className: 'even'
        },
        {
            description: 'Chance to win your shopping for FREE every week',
            sparks: true,
            sparksPlus: true,
            doubleTick: false,
            className: 'odd'
        },
        {
            description: 'Entry to a £1,000 prize giveaway',
            sparks: true,
            sparksPlus: true,
            doubleTick: false,
            className: 'even'
        },
        {
            description: 'Donations to your chosen charity',
            sparks: true,
            sparksPlus: false,
            doubleTick: true,
            className: 'odd'
        },
        {
            description: 'Monthly £10 voucher',
            sparks: false,
            sparksPlus: true,
            doubleTick: false,
            className: 'even'
        },
        {
            description: 'Unlimited FREE next-day delivery',
            sparks: false,
            sparksPlus: true,
            doubleTick: false,
            className: 'odd'
        },
        {
            description: 'Free hot drink every month in our café',
            sparks: false,
            sparksPlus: true,
            doubleTick: false,
            className: 'even'
        },
        {
            description: 'A special gift from Sparks Plus',
            sparks: false,
            sparksPlus: true,
            doubleTick: false,
            className: 'odd'
        },
        {
            description: 'Invites to in-store events',
            sparks: false,
            sparksPlus: true,
            doubleTick: false,
            className: 'even'
        },
        {
            description: 'Additional Sparks Plus exclusives',
            sparks: false,
            sparksPlus: true,
            doubleTick: false,
            className: 'odd'
        }],
        bottomSection: {
            titleOne: '30-day money-back guarantee',
            titleTwo: 'Over £200 worth of benefits',
            titleThree: 'Flexible renewal',
            descOne: 'Not happy within the first 30-days? Get your money back, no questions asked. Beyond 30 days, a pro-rated refund can be issued for any cancellations, so you can buy with confidence.',
            descTwo: 'More than £200 worth of benefits, all for just £120 a year, equal to £10 a month',
            descThree: 'Pay once for 12 months, then choose if you’d like to renew. We’ll contact you two months before your subscription ends.',
            subheading: ''
        },
        vipDescription: 'Can’t get enough of shopping with us? Make it <b>even</b> better by upgrading to Sparks Plus, our exclusive premium subscription service where you can enjoy unlimited next-day delivery and a whole host of extra special treats.',
        addToBagUrl: '/webapp/wcs/stores/servlet/AjaxOrderItemAddCmd',
        addToBagParams: 'productId=P60595613&storeId=10151&catalogId=10051&partNumber_1=60595613&quantity_1=1',
        checkoutPageUrl: '/OrderCalculate?calculationUsageIdentifier=MSBasketView_ShoppingCartURL&updatePrices=1&errorViewName=AjaxOrderItemDisplayView&orderId=.&langId=-24&doPrice=Y&URL=AjaxOrderItemDisplayView&storeId=10151&catalogId=10051',
        warningText: 'Something\'s wrong; please try adding to bag again',
        errorText: 'Unable to add to bag; please try refreshing the page',
        maxRetryCounter: 3,
        productId: 'P60595613',
        productName: 'Sparks Plus Subscription',
        productStroke: '8813X',
        productPrice: '120.00',
        productUpc: '28822639',
        maxQuantityErrorCode: '_ERR_MAX_QTY_ORDER_ITEM_ADD',
        maxQuantityErrorMessage: 'Sorry, this item is limited to one per customer',
        tncUrl: '/c/help/legal-and-ethical-policies/sparks-benefits-terms-and-conditions',
        sparksPlusSection: '#SPARKSPLUS',
        widgetLink: 'https://retailwidgets.appointedd.com/widget/62fe18e0dc59ff0835c82e57/widget.js',
        sparksPlusRoute: '/mysparks/sparksplus?storeId=10151&catalogId=10051',
        sparksPlusLinkText: 'Click to view the Sparks Plus details',
        offerId: '17328',
        offerRedeemed: 'REDEEMED'
    },
    appoinmentDetail: {
        title: 'Book your session',
        subTitle: 'Currently available in-store at:  Brooklands (Weybridge), Camberley (Surrey heath), and Hedge End (Southampton)',
        topBannerTitle: 'Personal Stylist Sessions',
        vipTitle: 'Get the VIP treatment...',
        vipDescription: 'As a member of Sparks Plus you can attend our exclusive Personal Stylist sessions twice a year, to compliment key season launches so you always have the latest style advice! <br /> <br /> Choose your store below, pick a date & time, bring along a friend for free (optional) and get that VIP treatment.',
        tempUnableTitle: 'Will be back later',
        tempUnableDescription: 'Bookings are closed for this season and will resume later. We will inform you when bookings open!',
        redeemedMsg: 'Sorry, we are unable to process your booking request currently. If you have already booked a slot, please cancel your current booking to reschedule your slot. If you have already attended a stylist session, we will let you know when you are able to book your next slot. If you need any further assistance, please call our contact centre.',
        faqTitle: 'Frequently Asked Questions',
        faqs: {
            id: 'acc-sparks-plus',
            accordionSections: [
                {
                    'label': 'How many times can I attend?',
                    'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                    'content': {
                        'text': 'You (and a plus one) are eligible to attend two seasonal stylist sessions each year: one for each season (seasons are defined as spring/summer and autumn/winter).'
                    }
                },
                {
                    'label': 'How many people can I bring with me?',
                    'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                    'content': {
                        'text': 'The session is for a maximum of two people. At the time of booking, you can either choose to book the session just for yourself, or for you and one friend or family member.'
                    }
                },
                {
                    'label': 'Where do I check-in when I arrive for my session?',
                    'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                    'content': {
                        'text': 'You will receive a reminder email prior to your appointment and it will contain the details of where to check-in when you arrive.'
                    }
                },
                {
                    'label': 'How do I reschedule my session?',
                    'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                    'content': {
                        'text': 'Your booking confirmation email provides an option to amend your booking. This will take you to the portal, where you can choose a new date and time slot. You will have to reschedule your session 24 hours before the original slot.'
                    }
                },
                {
                    'label': 'Why was my booking cancelled?',
                    'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                    'content': {
                        'text': 'If you have previously attended a session and booked another session, we will cancel it on your behalf as your membership provides one session per season. If you have multiple active sessions, we cancel your newer bookings on your behalf. You have the option to reschedule/cancel your active session, before booking a new one.'
                    }
                },
                {
                    'label': 'Why is it only available at select stores?',
                    'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                    'content': {
                        'text': 'Sparks Plus is currently an exclusive membership service that is available on an invite-only basis at select stores. We are working on expanding to more stores!'
                    }
                },
                {
                    'label': 'What are my other Sparks Plus benefits?',
                    'contentPartial': 'sparksPlusBenefitsContent',
                    'content': {
                        'partOne': 'You can view your Sparks Plus benefits',
                        'partTwo': 'We will also be sending you regular emails to remind you of your benefits and you can visit your Sparks Hub to see your offers too!',
                        'link': 'https://www.marksandspencer.com/mysparks/sparksplus?storeId=10151&catalogId=10051',
                        'linkText': 'here.'
                    }
                },
                {
                    'label': 'Can I gift my stylist session to someone?',
                    'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                    'content': {
                        'text': 'You can bring along a friend or family member with you for your session!'
                    }
                },
                {
                    'label': 'What happens if I can no longer attend my session?',
                    'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                    'content': {
                        'text': 'While we prefer that you cancel your session, if you are unable to attend, we understand that sometimes plans can change at the last minute. In most cases, we try to accommodate such a change to provide you with an alternative slot. However, this is subject to availability.'
                    }
                },
                {
                    'label': 'What happens if I don’t want to use this service?',
                    'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                    'content': {
                        'text': 'While we hope you do book and enjoy the stylist session, we understand it is not for everyone. If you choose not to utilise this benefit, this won’t affect your remaining Sparks Plus membership benefits.'
                    }
                }
            ]
        }
    },
    twelveDaysofSparksLink: '/mysparks/12daysofsparks#intid=spa_hub_all_bnr_advent-calendar_discover-now',
    twelveDaysofSparksOfferCount: 12,
    ACbackToSparksText: 'Back to Sparks',
    AChomeScreenDescriptionText: 'The Christmas countdown is on! Come back every day to unlock a new reward',
    AChomeScreenHowItWorksText: 'How it works',
    AChomeScreenAppDownloadText: 'Come back every day – or you’ll miss your reward. Use the app for extra time to open. Scan the QR code to download ',
    AChomeScreenAppDownloadTextMob: 'Come back every day – or you’ll miss your reward. Use the app for extra time to open',
    adventCalendarTomorrow: {
        advertCalendertitle: 'Come back tomorrow!',
        advertCalenderDesc: 'Good things come to those who wait. But you can check out what rewards you’ve collected already.'
    },
    adventCalendarFuture: {
        advertCalendertitle: 'No peeking! ',
        advertCalenderDesc: 'You’re a bit early, come back on the correct day to unlock this door.Check out what rewards you’ve unlocked already'
    },
    adventCalendarMissed: {
        advertCalendertitle: 'Oh snow!',
        advertCalenderDesc: 'Sorry, you didn’t open this door in time. But you can check out what rewards you’ve collected already'
    },
    adventCalendarYesterday: {
        advertCalendertitle: 'Don’t miss out',
        advertCalenderDesc: 'You can still open yesterday’s door – just download the M&S app'
    },
    adventCalendarUnlocked: {
        advertCalendertitle: 'You\'ve unlocked 13',
        advertCalenderDesc: 'Congratulations! You\'ve opened all 12 doors and have unlocked a bonus 13th reward on the app. Download the M&S app to unlock now'
    },
    adventCalendarViewButton: 'View my offers',
    AChomeViewOfferRedirectURLParam: '?viewcalendaroffers#intid=sparksnav_advent-calendar_offer_view-added-offers',
    AChomeOfferDetailsShopOfferText: 'Shop the offer',
    AChomeOfferDetailsViewAddedOfferText: 'View added offers',
    AChomeOfferDetailsExpirePreText: 'Expires',
    AChomeOfferDetailsSingleUseText: 'Single use',
    AChomeOfferDetailsTermsHeaderText: 'Terms and conditions',
    AChomeOfferDetailsMoreInformationText: 'More information',
    AChomeOfferDetailsLessInformationText: 'Less information',
    AChomeOfferDetailsRedeemedOfferText: 'You have redeemed this offer',
    AChomeOfferDetailsInStoreAndOnlineText: 'In-store & online',
    AChomeOfferDetailsInStoreText: 'In-store',
    AChomeOfferDetailsOnlineText: 'Online',
    adventCalendarBannerHeader: '12 DAYS OF',
    adventCalendarBannerTitle: 'We’re giving away 1,000s of treats! Plus, personalised offers and exclusive competitions. Scan the QR code to download the M&S app for an even more magical experience',
    adventCalendarBannerTitleMob: 'We’re giving away 1,000s of treats! Plus, personalised offers and exclusive competitions. Download the app for a more magical experience',
    adventCalendarBannerTitlePost12Days: 'Congratulations! You’ve unlocked all 12 rewards. Your golden reward will arrive tomorrow…',
    adventCalendarBannerBodyPost12Days: '',
    adventCalendarBannerButtonText: 'Unlock today’s reward',
    adventCalendarOfferAddedTitle: '12 days of Sparks',
    ACHIWHeader: 'How it works',
    ACHIWDescription: 'Between 1 - 12 December, a new reward will be hidden behind your door every day.   Just tap to unlock and your reward will automatically appear in your ‘added offers’.   You have 24-hours to unlock each reward, download the app for extra time – so don’t miss out. And no peeking ahead either! Doors can’t be opened early.   Open all 12 days and you’ll receive a bonus golden reward on day 13',
    adventCalendarShoptheOffer: '#intid=sparksnav_advent-calendar_offer_shop-offer_',
    adventCalendarEndDate: '2022-12-13',
    thumbnailsStampTitle: 'Sparks Stamps ',
    thumbnailsStampDesc: 'Collect a stamp every time you buy an M&S hot drink and get your 7th on us',
    POSCampaignTitle: 'Love M&S, Love Savings, Love Sparks',
    POSCampaignText: 'Enjoy great savings on the things you love with Sparks',
    POSCampaigntitle1:'JOIN SP',
    POSCampaigntitle2: 'RKS FOR REWARDS YOU\'LL LOVE',
    POSBenefitsPersonalisedOffers: 'Offers just for you',
    POSBenefitsPersonalisedOffersDesc: 'Get personalised offers on the things you love.',
    POSBenefitsChanceToGet: 'The chance to get what you’re buying for free',
    POSBenefitsChanceToGetDesc:'Every week in store, we\'ll treat a Sparks customer to the shopping they\'re buying, for free.',
    POSBenefitsLittleThankYou: 'Little thank yous, just because',
    POSBenefitsLittleThankYousDesc:'Every day we\'ll surprise lucky customers with a little gift.',
    POSBenefitsCharityDonation: 'Charity donations',
    POSBenefitsCharityDonationDesc: 'We\'ll make a donation to your chosen charity every time you shop.',
    POSBenefitsChanceToWin: 'Enjoy a hot drink on us ',
    POSBenefitsChanceToWinDesc: 'Buy six hot drinks in store and get one for free ',
    dpSpOfferStatus: ['ALLOCATED', 'REDEEMED'],
    variantBannerTitle1:'YOU GET MORE WITH',
    variantBannerTitle2:'SP',
    variantBannerTitle3:'RKS',
    variantBannerMobileTitle1:'YOU GET MORE ',
    variantBannerMobileTitle2:'WITH ',
    variantBannerSubtext:'10% off when you sign up to Sparks*',
    variantBannerBtn:'Sign up',
    variantBannerAlreadyMember:'Already a member?',
    variantBannerViewRewards:'Sign in to view your rewards',
    campaignIdLabel: 'campaignId',
    // subCampaignIdLabel: 'subCampaignId',
    // channelIdLabel:'channelId',
    offerFrequencyLabel: 'offerFrequency',
    globalIdLabel: 'offerId',
    validityDurationLabel: 'validityDuration',
    qrToolButton: 'submit',
    startDateLabel: 'start date',
    endDateLabel: 'end date',
    // plutoEnabledLabel:'pluto Enabled',
    validityEndDateLabel: 'validity end date',
    qrSuccessMsg:'successfully updated',
    creditCardRewardsFaq: {
        id: 'drRewardsFaq',
        accordionSections: [
            {
                'label': 'What is M&S Credit Card Rewards?',
                'contentPartial': 'drFaqLink',
                'content': {
                    'text': 'M&S Credit Card Rewards allows you to earn Rewards points every time you spend on your M&S Credit Card. These points will be converted into Rewards vouchers for you to spend at M&S. <a href="https://bank.marksandspencer.com/credit-card/rewards/?cid=HBEU:ma:O0:NA:NA:2205:010:RewardsNav" target="_blank" rel="noopener">Find out more about M&S Credit Card Rewards.</a>'
                }
            },
            {
                'label': 'How can I receive Credit Card Rewards online?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'You can now connect your Sparks account with your M&S Credit Card account so you can view and use your Rewards vouchers and Bonus Offers in your Sparks account via the M&S app.'
                }
            },
            {
                'label': 'Will I still get my Rewards vouchers or Bonus Offers in the post?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'No – if you’re registered, you’ll now see your live Rewards vouchers and Bonus Offers in your Sparks account. However, if you register after your quarterly mailer has been prepared, you may receive one final mailer. Rewards in your paper mailer are the same as Rewards in your Sparks account. Bonus Offers and Rewards vouchers are single use. This means you can’t use the Rewards in your paper mailer as well as in your Sparks account.'
                }
            },
            {
                'label': 'What should I do if I have received Credit Card Rewards online and I also receive my quarterly mailer?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'Due to printing timings, you may still receive a quarterly mailer after you receive Credit Card Rewards online. You can’t use both paper and online vouchers – each voucher can only be used once. Please destroy and recycle your paper vouchers.'
                }
            },
            {
                'label': 'Where can I find out more about my M&S Credit Card?',
                'contentPartial': 'drFaqLink',
                'content': {
                    'text': '<a href="https://bank.marksandspencer.com/credit-card/rewards/?cid=HBEU:ma:O0:NA:NA:2205:010:RewardsNav" target="_blank" rel="noopener">Find out more about the M&S Credit Card.</a>'
                }
            },
            {
                'label': 'How can I download the M&S app?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'For Apple devices, click on the app store, choose the M&S app and click download. For Android devices, open the Play Store, choose the M&S app and click install. You may need to update your device’s operating system to run the M&S app.'
                }
            },
            {
                'label': 'Can I receive my Club Rewards in my Sparks account?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'Club Rewards aren’t available in your M&S Sparks account yet, but we’re working on it.'
                }
            },
            {
                'label': 'Do I need to be registered with Sparks?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'Yes – all your Rewards will be available in your Sparks account. If you don’t have a Sparks account, we’ll sign you up when you register online at marksandspencer.com. Don’t forget to check your marketing preferences when you sign up.'
                }
            },
            {
                'label': 'Why do you ask for my M&S Credit Card account details?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'We ask for your M&S Credit Card account details so we can provide you with your personal Rewards in your Sparks account.'
                }
            },
            {
                'label': 'What details will I need to provide so I can access Credit Card Rewards?',
                'contentPartial': 'drFaqLink',
                'content': {
                    'text': 'You’ll need to sign in to the M&S Banking app or internet banking. If you haven’t done this for a while or need some support, you can use our <a href="https://va.marksandspencer.com/mobileandinternetbankingaccesshelptool/?&va=MIBAHT" target="_blank" rel="noopener">internet banking access help tool</a>.'
                }
            },
            {
                'label': 'Why do you ask for a mobile phone number?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'To keep your Rewards safe, you may be asked to provide your mobile phone number, and occasionally to enter a one-time password that we’ll send to that mobile phone.'
                }
            },
            {
                'label': 'Can I link someone else’s Sparks account to my M&S Bank Credit Card account?',
                'contentPartial': 'drFaqLink',
                'content': {
                    'text': 'No – you can only link an account in your name. <a href="https://www.marksandspencer.com/JoinSparks" target="_blank" rel="noopener">Find out more about joining Sparks</a>.'
                }
            },
            {
                'label': 'What if I have two Sparks accounts?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'It’s really important to link to the right account, so please make sure you login to the Sparks account you want to link to your M&S Bank Credit Card account.'
                }
            },
            {
                'label': 'What do I do when I’m registering and I’m asked to download the M&S Banking app, when I already have it on my phone?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'Some devices can be configured not to open apps directly from a webpage. If you’re asked to download the M&S Banking app just click Cancel and you’ll go to the M&S Bank website, where you can complete registration.'
                }
            },
            {
                'label': 'When I’m registering, how do I get an M&S Bank security code?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'Just open your M&S Bank app – click on Generate security code, then click on Internet Banking – Sign in code. You can then generate your security code.'
                }
            },
            {
                'label': 'What if I didn’t get a text message with my one-time password',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'Check your phone has reception and isn’t set to airplane mode.'
                }
            },
            {
                'label': 'Will I have to update to the latest version of the M&S app?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'Yes – Credit Card Rewards aren’t available on earlier versions of the M&S app, so you may need to update to the latest version.'
                }
            },
            {
                'label': 'What Rewards will I see when I join?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'You’ll see your available Rewards vouchers and how they’ve been earned on your M&S Credit Card. You’ll also see any available Bonus Offers. It may take 1-2 days for these to appear in your Sparks account.'
                }
            },
            {
                'label': 'What if I don’t have any Bonus Offers?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'Just like now, you’ll have Bonus Offers for around six weeks each quarter.'
                }
            },
            {
                'label': 'Can I register for Credit Card Rewards online if I’m a Chargecard or Budgetcard customer?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'Credit Card Rewards online are only available to M&S Credit Card customers.'
                }
            },
            {
                'label': 'How can I use my Rewards vouchers and Bonus Offers in store?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'You can access your Rewards vouchers and Bonus Offers in your Sparks account with the M&S app. Simply open the Rewards voucher or Bonus Offer and scan the barcode at the till.'
                }
            },
            {
                'label': 'When I’m buying in store, does it matter when I scan my rewards?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'Yes. Just like now, use your Sparks card and your Bonus Offers while you’re scanning your items. To use your Rewards vouchers, remember to select ‘Loyalty vouchers’ when it’s time to pay.'
                }
            },
            {
                'label': 'How can I use my Rewards vouchers and Bonus Offers online at marksandspencer.com and on the M&S app?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'When you shop online at marksandspencer.com or on the M&S app, you can apply your Rewards vouchers and Bonus Offers at the checkout. Look out for your Rewards vouchers and Bonus Offers in the payment section, and simply choose the ones you’d like to use.'
                }
            },
            {
                'label': 'Are there any products I can’t pay for with Rewards vouchers?',
                'contentPartial': 'drFaqLink',
                'content': {
                    'text': 'You can’t use Rewards vouchers to pay for M&S gift vouchers, gift cards, e-gift cards, M&S Travel Money, foreign exchange purchases, cash advances/withdrawals or lottery tickets. M&S Rewards vouchers cannot be used to pay your M&S Credit Card account. <a href="https://bank.marksandspencer.com/pdf/LoyaltyTermsAndConditions.pdf" target="_blank" rel="noopener">Find out more about Rewards vouchers restrictions.</a>'
                }
            },
            {
                'label': 'How can I view my Rewards vouchers or Bonus Offers online?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'Your Rewards vouchers and Bonus Offers can be accessed in your Sparks account at marksandspencer.com or on the M&S app.'
                }
            },
            {
                'label': 'Do Rewards vouchers expire?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'Yes – Rewards vouchers do expire. Paper Rewards vouchers are valid for 15 months. Rewards vouchers in your Sparks account are valid for 17 months, as they’re displayed around two months earlier, which gives you a bit more time to use them.'
                }
            },
            {
                'label': 'How do M&S Rewards points work?',
                'contentPartial': 'drFaqLink',
                'content': {
                    'text': '<a href="https://bank.marksandspencer.com/credit-card/rewards/?cid=HBEU:ma:O0:NA:NA:2205:010:RewardsNav" target="_blank" rel="noopener">Find out more about earning M&S Rewards points.</a>'
                }
            },
            {
                'label': 'Why don’t I have any Rewards vouchers in my Sparks account?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'You need at least 200 M&S Rewards points to receive Rewards vouchers. Any valid Bonus Offers will be made available in your Sparks account. Rewards vouchers and Bonus Offers will be added quarterly.'
                }
            },
            {
                'label': 'If I haven’t used my M&S Bank Credit Card in the quarter, will I see a quarterly points summary?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'No. You’ll only see a quarterly points summary if you’ve used your M&S Credit Card and have earned M&S Rewards points.'
                }
            },
            {
                'label': 'Why can’t I log in?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'If you’ve forgotten your email/password, you will need to follow the steps on the M&S.Com website to correct this and log in. For extra security, Credit Card Rewards customers have 2-Factor Authentication enabled on your account. Occasionally to keep your account safe, you may be required to follow extra security checks. When this happens, you will be sent a one-time password to your mobile number to enter on screen. Please follow the steps shown on your mobile screen.'
                }
            },
            {
                'label': 'Can I return items I’ve bought with Rewards vouchers?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'Yes - When you purchase with Rewards vouchers and return/refund in store, you’ll be issued with a credit note to spend at M&S. If you purchase with Rewards vouchers and return/refund at one of our Simply Foods stores or on the M&S website, you’ll be issued a gift card to spend at M&S.'
                }
            },
            {
                'label': 'Will I get change when I use Rewards vouchers?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'No – if the value of the Rewards voucher is more than the value of the items you’re buying, you won’t receive change.'
                }
            },
            {
                'label': 'Where can I use my Rewards vouchers and Bonus Offers?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'You can use your Rewards vouchers or Bonus Offers in M&S stores and at marksandspencer.com. Restrictions can be found in the terms and conditions for each Rewards voucher and Bonus Offer.'
                }
            },
            {
                'label': 'How often will I receive Rewards in my Sparks account?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'Your M&S Rewards points will be converted to Rewards vouchers four times a year, usually in March, June, September and December.'
                }
            },
            {
                'label': 'Where in my Sparks account can I check how many M&S Rewards points I have?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'You can find your Rewards account details in your Sparks account, including your current M&S Rewards points balance, plus points and Rewards vouchers for the past six points earnings periods.'
                }
            },
            {
                'label': 'How quickly will I see my current M&S Rewards points balance update?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'Because of payment processing times it may take up to 48 hours between your transaction on your M&S Credit Card, and your M&S Rewards points being updated.'
                }
            },
            {
                'label': 'Why has the points earnings period ended, but I haven’t yet received my M&S Rewards vouchers in my Sparks account?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'There may be a delay while your points are being converted to M&S Rewards vouchers, this processing time is normal and to be expected.'
                }
            },
            {
                'label': 'If I update my personal details with M&S Bank, will my details be updated automatically in my Sparks account?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'No – any personal details changed with M&S Bank won’t be updated in your Sparks account. You’ll need to update your details separately in each account.'
                }
            },
            {
                'label': 'If I update my personal details in my Sparks account, will my details be updated automatically with M&S Bank?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'No – any personal details changed in your Sparks account won’t be updated with M&S Bank. You’ll need to update your details separately in each account.'
                }
            },
            {
                'label': 'What happens to my Rewards vouchers if I close my M&S Credit Card?',
                'contentPartial': 'mns-fe-patterns/elements/badge/markup',
                'content': {
                    'text': 'If you close your M&S Credit Card, you’ll still be able to access your live Rewards vouchers in your Sparks account.'
                }
            }
        ]
    },
    myAccount: 'my account',
    digitalTitle: 'Never lose a receipt again!',
    digitalDesc1:'As a valued Sparks customer, you have been selected to go paperless!',
    digitalDesc2:'Your receipts will now be safely stored in your Sparks account on the M&S app and website, instead of being printed in store.',
    digitalDesc3:'A copy will be sent to you via email too.',
    digitalReceiptPopupButton:'Thanks, got it!',
    digitalLink:'Change your receipt settings',
    digitalReceiptPopup: 'OPTIN_RECEIPTS',
    rewardsAccountInfoText1: 'Your future Credit Card Rewards will be made available to you in your Sparks account. Please note Rewards are updated on a quarterly basis.',
    rewardsAccountInfoText2: 'Your Credit Card Rewards will remain available in your Sparks account until they are redeemed or expire. Due to printing cycles it may take longer than three months for your quarterly mailer to be delivered.',
    rewardsAccountPromptQM: 'Are you sure you want to change to quarterly mailer?',
    rewardsAccountPromptY: 'Apply change',
    rewardsAccountPromptN: 'Don\'t change',
    rewardsAccountSuccessMsg: 'Preferences saved',
    rewardsAccountUrl: '/mysparks/myrewards/account',
    rewardsAccountDDText1: 'In your Sparks account',
    rewardsAccountDDText2: 'Quarterly Rewards Mailer',
    addToWalletErrorMsg: 'We had an issue adding your Sparks Card, please try again',
    ccrAirgapInfo: 'We are currently converting your points into Rewards vouchers. If you\'ve earned more than 200 points, your Rewards vouchers will be available here soon. Don\'t worry if you haven\'t, your balance will be carried over.',
    ccrAccountExistsError: 'This M&S Bank Account has already been linked. To access your Credit Card Rewards please sign in to the Sparks account that previously linked.',
    ccrAccountLinkingError: 'Sorry, we\'re unable to link your accounts right now. Please try again later.',
    stampsThumbnailLink: 'https://www.marksandspencer.com/mysparks/qrcode?campaign=ALWAYSON_APPONLY_STREAK_COFFEE_12_2021&extid=qr_sparks_ALWAYSON_APPONLY_STREAK_COFFEE_12_2021',
    prizeDraw: {
        badge: 'Prize Draw',
        closeDatePrefix: 'Draw closes by',
        enterCta: 'Enter now',
        enteredCta: 'More details'
    }
};
